import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import './PaymentInfo.css';

import {
  fetchPaymentMethods,
  selectPaymentMethod,
  selectBank,
  clearAlerts,
  selectPaymentCreditCard,
  openModalSafetypay,
} from '../../../actions/purchaseActions';

import Cash from './Cash';
import Boleto from './Boleto';
import CreditCard from './CreditCard';
import CashTransfer from './CashTransfer';
import Pix from './Pix';
import Alert from './Alert';

import PaymentMethodMobile from './mobile/PaymentMethodMobile';

import getCreditCardInput from './desktop/inputs/getCreditCardInput';
import getBoletoInput from './desktop/inputs/getBoletoInput';
import getPixInput from './desktop/inputs/getPixInput';

import { formatPrice } from '../../../utils';

class PaymentMethod extends Component {
  componentWillMount(props) {
    const today = new Date();
    const deadline = today.addDays(1);
    const year = deadline.getUTCFullYear();
    const month = (deadline.getUTCMonth() + 1).toLocaleString('pt-BR', { minimumIntegerDigits: 2 });
    const day = deadline.getUTCDate().toLocaleString('pt-BR', { minimumIntegerDigits: 2 });
    this.deadline = `${day}/${month}/${year}`;
  }

  render() {
    const payments = [];

    this.props.paymentMethods.sort((a, b) =>
      a.displayOrder > b.displayOrder ? 1 : b.displayOrder > a.displayOrder ? -1 : 0
    );

    for (let i = 0; i < this.props.paymentMethods.length; i++) {
      const method = this.props.paymentMethods[i];

      if (method.active && method.available) {
        if (method.slug === 'credit-card') {
          payments.push(<li key={`credit-card-${i}`}>{getCreditCardInput(this.props, i)}</li>);
        } else if (method.slug === 'boleto') {
          payments.push(<li key={`boleto-${i}`}>{getBoletoInput(this.props, i)}</li>);
        } else if (method.slug === 'pix') {
          payments.push(<li key={`pix-${i}`}>{getPixInput(this.props, i)}</li>);
        }
      }
    }

    return <ul className="lista-opcoes-pagamento desktop radio-input">{payments}</ul>;
  }
}

class PaymentInfo extends Component {
  constructor(props) {
    super(props);

    this.paymentMethods = [
      { id: 0, render: <CreditCard /> },
      { id: 1, render: <Boleto /> },
      { id: 3, render: <CashTransfer banks={this.props.banks} selectBank={this.props.selectBank} /> },
      { id: 2, render: <Cash /> },
      { id: 4, render: <Pix /> },
    ];
  }
  render() {
    const selectedPaymentMethod = this.props.paymentMethods.filter((method) => method.selected)[0];
    const safetypayMinValue = formatPrice(this.props.safetypay.min_value);
    const boletoMinValue = formatPrice(this.props.boleto.min_value);

    let paymentMethod = {};
    let pmComponent = null;

    if (selectedPaymentMethod) {
      paymentMethod = this.paymentMethods.filter((method) => method.id === selectedPaymentMethod.id).pop();
      if (paymentMethod) {
        pmComponent = paymentMethod.render;
      }
    }

    return (
      <div
        className="card-forma-pagamento"
        style={{ display: this.props.stagePurchase !== 2 && this.props.mobile ? 'none' : 'block' }}
      >
        <div className="box-item">
          <h3
            className="card-forma-pagamento-header"
            style={{ display: this.props.stepDisplayMethodPayment === 0 && this.props.mobile ? 'block' : 'none' }}
          >
            <span className="mobile">Selecione a forma de pagamento:</span>
          </h3>

          <div className="body-box-item">
            <div style={{ display: this.props.stepDisplayMethodPayment !== 0 && this.props.mobile ? 'none' : 'block' }}>
              <div className="mobile">
                {this.props.alert === 'boleto' && (
                  <Alert onClose={this.props.clearAlerts}>
                    A opção de pagamento por boleto está disponível somente para valores{' '}
                    <b>acima de R$&nbsp;{boletoMinValue}</b> e com <b>prazo de 2 dias</b> para a viagem.
                  </Alert>
                )}
              </div>

              {!this.props.mobile ? (
                this.props.purchaseSummary.total > 0 && (
                  <Fragment>
                    <span className="payment-desktop-header">Forma de pagamento</span>
                    <PaymentMethod
                      fetchPaymentMethods={this.props.fetchPaymentMethods}
                      paymentMethods={this.props.paymentMethods}
                      selectedPaymentMethod={this.props.selectedPaymentMethod}
                      selectPaymentMethod={this.props.selectPaymentMethod}
                      brands={this.props.brands}
                      openModalSafetypay={this.props.openModalSafetypay}
                      userDetails={this.props.userDetails}
                      partner={this.props.paramsUrl.partner}
                    />
                  </Fragment>
                )
              ) : (
                <PaymentMethodMobile
                  fetchPaymentMethods={this.props.fetchPaymentMethods}
                  selectedPaymentMethod={this.props.selectedPaymentMethod}
                  selectPaymentMethod={this.props.selectPaymentMethod}
                />
              )}
            </div>

            <div className="desktop">
              {this.props.alert === 'boleto' && (
                <Alert onClose={this.props.clearAlerts}>
                  A opção de pagamento por boleto está disponível somente para valores{' '}
                  <b>acima de R$&nbsp;{boletoMinValue}</b> e com <b>prazo de 2 dias</b> para a viagem.
                </Alert>
              )}
            </div>

            <div
              className="area-forma-pagamento"
              style={this.props.purchaseSummary.total === 0 ? { borderTop: 'none' } : {}}
            >
              {pmComponent}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    alert: state.purchase.alert,
    banks: state.purchase.banks,
    safetypay: state.purchase.safetypay,
    boleto: state.purchase.boleto,
    paymentMethods: state.purchase.paymentMethods,
    mobile: state.mobile.mobileActive,
    stagePurchase: state.purchase.stagePurchase,
    stepDisplayMethodPayment: state.purchase.stepDisplayMethodPayment,
    stepDisplayCreditCard: state.purchase.stepDisplayCreditCard,
    plan: state.search.plans,
    brands: state.purchase.creditCard.brands,
    userDetails: state.purchase.userDetails,
    purchaseSummary: state.purchase.purchaseSummary,
  }),
  {
    fetchPaymentMethods,
    selectPaymentMethod,
    selectBank,
    clearAlerts,
    selectPaymentCreditCard,
    openModalSafetypay,
  }
)(PaymentInfo);



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/PaymentInfo.jsx